import { render, staticRenderFns } from "./reviewDetailBox_wx.vue?vue&type=template&id=19ae6e34"
import script from "./reviewDetailBox_wx.vue?vue&type=script&lang=js"
export * from "./reviewDetailBox_wx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports